module.exports = __webpack_public_path__ + "imgs/psb-back@1x-min.77f3b7b9.webp";